import CloseIcon from "@mui/icons-material/Close";

export function UnapprovedEmployeeModal({ isOpen,
	onClose,
	employees,
}) {
	const handleClose = () => {
		onClose();
	};

	return (
		<>
			<div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Added / Unapproved Employees</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div className="popUp-body">
							<div className='column'>
								<div style={{ margin: "10px 0 30px 0" }}>
									This is the list of unapproved employees.
									<br />
									<br />To approve this, select "Pending" in filter then select employee and click "Approve".
								</div>
								{employees.map((employee, index) => {
									return (
										<div key={index} style={{ margin: "10px 0" }}>
											{`${employee.employeeId} - ${employee.fullName}`}
										</div>
									)
								})}
							</div>
						</div>
						<div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
							<button id="add-family"
								className="cancel row"
								onClick={handleClose}>
								Close
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}